export type UserChangePasswordRequestDto = {
  password: string;
  new_password: string;
};

export const initialUserChangePasswordRequestDto: UserChangePasswordRequestDto = {
  password: '',
  new_password: '',
};
